import React from "react";
import { Reveal } from "@/lib/motion";
import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "Working with Nathan has completely changed my approach to the gym. He's helped me stay consistent, push myself further and understand how to train properly to achieve my fitness goals. He helped me make great progress and I would definitely recommend him to anyone looking to improve their fitness.",
    name: "Damien R.",
    role: "Client · New Zealand",
  },
  {
    quote:
      "Nathan is an exceptional personal trainer with a level of knowledge and training wisdom that is genuinely rare. He has an incredible understanding of fundamental training principles and consistently provides highly effective, personalised advice based on each person's goals and individual needs.",
    name: "Max D.",
    role: "Client · New Zealand",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative border-t border-white/10 py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.28em] text-white/40">Testimonials</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 mb-16 md:mb-24 font-syne font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[0.98] max-w-3xl">
            The work <span className="font-cormorant italic font-light text-white/60">speaks.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <motion.figure
                whileHover={{ y: -6 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                data-testid={`testimonial-card-${i}`}
                className="group glass rounded-2xl p-10 md:p-14 h-full flex flex-col justify-between hover:border-white/25"
              >
                <span className="font-cormorant italic text-6xl text-white/15 leading-none">"</span>
                <blockquote className="mt-2 font-syne text-xl md:text-2xl font-medium tracking-tight leading-snug text-white/90">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-10 pt-6 border-t border-white/10 flex items-center justify-between">
                  <span className="font-syne font-semibold">{t.name}</span>
                  <span className="text-xs uppercase tracking-[0.2em] text-white/40">{t.role}</span>
                </figcaption>
              </motion.figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
